import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgList = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.75,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "M3 5h.01" }),
		/* @__PURE__ */ _jsx("path", { d: "M3 12h.01" }),
		/* @__PURE__ */ _jsx("path", { d: "M3 19h.01" }),
		/* @__PURE__ */ _jsx("path", { d: "M8 5h13" }),
		/* @__PURE__ */ _jsx("path", { d: "M8 12h13" }),
		/* @__PURE__ */ _jsx("path", { d: "M8 19h13" })
	]
});
const ForwardRef = forwardRef(SvgList);
export default ForwardRef;
